import { HeaderSecondLevel } from '@engbers/components/header-second-level';
export const HeaderSecondLevelTastic = ({
  data
}) => {
  return <div data-sentry-component="HeaderSecondLevelTastic" data-sentry-source-file="index.tsx">
      <HeaderSecondLevel link={data.backLink} bgColor={data.bgColor} textColor={data.textColor} icon={data.icon} title={data.title} isWishlist={data.isWishlist} data-sentry-element="HeaderSecondLevel" data-sentry-source-file="index.tsx" />
    </div>;
};